/**
 * Cheap local signal for the eager manifest (no chunk, no request): could friends have served
 * customers at this player's shop? Only friends can, and every serve leaves the victim an inbox
 * note, which the inbox's map hook (mapOrder 10, before this one) counts in `inboxUnread`. Once a
 * steal list had anything in it (either side), the player keeps being checked. Players with
 * neither (no friends yet) skip GET /v1/steals.
 */
import type { AppContext } from '../../game/context.js';

const KNOWN_KEY = 'steal.known';

export function mayHaveVisitors(a: Pick<AppContext, 'services'>): boolean {
  return a.services.store.state.prompts.inboxUnread > 0 || a.services.kv.get(KNOWN_KEY) === '1';
}

/** The player has friends who serve or get served: keep checking for visitors every session. */
export function markKnown(a: Pick<AppContext, 'services'>): void {
  if (a.services.kv.get(KNOWN_KEY) !== '1') a.services.kv.set(KNOWN_KEY, '1');
}
